import React, { createContext, useContext } from 'react';

const ModalContext = createContext({
  isProcessing: false,
  onClose: () => {}
});

export const useModal = () => useContext(ModalContext);

export function ModalProvider({
  isProcessing = false,
  onClose = () => {},
  children = null
}) {
  return (
    <ModalContext.Provider value={{ isProcessing, onClose }}>
      {children}
    </ModalContext.Provider>
  );
}
